"use client";
import * as React from "react";
const SvgExpandMoreRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 8", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M9.88 1 5.99 4.88 2.13 1A1 1 0 1 0 .7 2.41L5.3 7a1 1 0 0 0 1.4 0l4.6-4.59a1 1 0 0 0 0-1.41 1 1 0 0 0-1.43 0" }));
export {
  SvgExpandMoreRound as default
};
